<template>
  <div>

    <!-- 无法拨打 -->
    <div v-if="!modalIf" style="cursor:pointer;" :style="{color:phoneColor}" @click="openChangePhone" :title="phoneFlagText">
        <Icon type="iphone" class="phone-icon"></Icon>
      {{userInfoCall}}
    </div>

    <div v-else>
      <Poptip v-model="modalIf"  :showPop="closeModal" trigger="click" placement="bottom-start" width="100" style="cursor: pointer" :options="test">
      <Icon type="iphone" :style="{color:phoneColor}" class="phone-icon"></Icon>
      <span :style="{color:phoneColor}" :title="phoneFlagText">
        <!-- <img :src="statusSrc" style="height: 18px;margin-right:4px;vertical-align: middle;"> -->
        {{userInfoCall}}
      </span>
        <div slot="content">
          <Button type="ghost" size="small" style="margin:0 10px 4px 0;display: block;color:#303133;" @click="changePhoneState(0)">
            未拨打
          </Button>
          <Button type="ghost" size="small" style="margin:0 10px 4px 0;display: block;color:#2b85e4;" @click="changePhoneState(1)">
            已拨打
          </Button>
          <Button type="ghost" size="small" style="margin:0 10px 4px 0;display: block;color:#19be6b;" @click="changePhoneState(2)">
            已接听
          </Button>
          <Button type="ghost" size="small" style="margin:0 10px 4px 0;display: block;color:#ff9900;" @click="changePhoneState(3)">
            未接听
          </Button>
        </div>
      </Poptip>
    </div>

    <!-- 通话记录 -->
    <Modal v-model="Conversation" title="通话记录" width="700" @on-cancel="closeCall" style="z-index: 1010;">
      <Table :loading="seeCall.loading" :columns="seeCall.column" :data="seeCall.data" border class="table-small">
      </Table>
      <div style="text-align:right;height:30px;margin-top:10px;">
        <Page @on-change="changePageCall" :total="seeCall.totalCount" show-total size="small"></Page>
      </div>
      <div style="text-align: right;width:100%;margin-top:10px;">
        <audio :src="map_url" controls="controls" autoplay style="width:100%"></audio>
      </div>
      <div slot="footer" style="text-align: center">
        <Button type="ghost" @click="closeCall">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import clipboard from 'clipboard-polyfill'
  import {dataDst} from "../../common/util"
  import timeUtil from '../../common/time-util'
  import {Page} from 'iview'
  import {Icon} from 'iview'

  export default {
    name: "kz-phone",
    props: {
      phone: {
        type: Object,
      },
      encryption: {
        type: Boolean,
      },
      kzPhoneFlag:{
        type:[Number,String]
      },
      kzId:{
        type:[Number,String]
      },
      kzPhoneStatus:{
        type:[Number,String]
      }
    },
    components:{Page,Icon},
    data() {
      return {
        test:{
          modifiers: {
            computeStyle:{
              gpuAcceleration: false,
            },
            preventOverflow :{
              boundariesElement: 'window'
            },
            onCreate: function(){
              console.log(13)
            }
          }
        },
        modalIf:false,
        modalShow: false,
        newPhoneStatus:false,
        closeModal: '关闭',
        phoneText: '',
        statusSrc: '',
        Conversation: false,
        phoneId: '',
        map_url:'',
        seeCall: {
          column: [
            {
              title: '呼叫时间',
              key: 'startTime',
              width: 150,
            },
            {
              title: '呼叫时常',
              key: 'totalDuration',
              width:90,
            },
            {
              title: '呼叫结果',
              key: 'status',
              width:90,
            },
            {
              title: '呼叫人',
              key: 'customerNumber',
              width:120,
            },
            {
              title: '客户号码',
              key: 'clientNumber',
              width:120,
            },
            {
              title: '录音文件',
              key: 'fileName',
              render: (h, params) => {
                if (params.row.fileName) {
                  return h('Button', {
                    props: {
                      type: 'primary',
                      size:'small',
                    },
                    on: {
                      click: () => {
                        this.$http.get(`/call/get_recording_file?fileName=${params.row.fileName}&callId=${this.callCustomerPO.callId}`).then(data => {
                          if(data.code === 100000){
                            this.map_url = data.data.MediaDownloadParam.SignatureUrl.replace(/"/g,'')
                          }else {
                            this.$Message.error(data.msg)
                          }
                        })
                      }
                    }
                  }, '播放')
                } else {
                  return h('span', '无录音')
                }
              }
            }
          ],
          data: [],
          loading:false,
          totalCount:0,
        },
        phoneStateColor: {
          '0': '#303133',
          '1': '#2b85e4',
          '2': '#19be6b',
          '3': '#ff9900',
        },
        phoneStateText: {
          '0': '未拨打',
          '1': '已拨打',
          '2': '已接听',
          '3': '未接听',
        },
      }
    },
    computed: {
      ...mapGetters(['loginStatus','userInfo','callCustomerPO']),

      userInfoCall() {
        if (this.encryption) {
          this.phoneText = dataDst(this.phone.row.kzphone)
          // this.$store.commit('setLoginStatus', false)
        } else {
          this.phoneText = this.phone.row.kzphone
        }
        // if (this.loginStatus) {
        //   this.modalShow = false
        //   this.statusSrc = 'https://oss.aliyuncs.com/hmcrm/beidou/icon_flag/type_hunshazhao.png'
        // } else {
        //
        // }
        this.statusSrc = 'https://oss.aliyuncs.com/hmcrm/beidou/icon_flag/tel_green.png'

        return this.phoneText
      },

      phoneColor(){
        let flagColor = ''
        if(this.newPhoneStatus){
          flagColor = this.phoneStateColor[this.newPhoneStatus]
        }
        return flagColor
      },
      phoneFlagText(){
        let flagText = ''
        if(this.newPhoneStatus){
          flagText = this.phoneStateText[this.newPhoneStatus]
        }
        return flagText
      },
    },
    mounted(){
      this.$nextTick(()=>{
        this.newPhoneStatus = this.kzPhoneStatus
      })
    },
    methods: {
      openChangePhone(){
        this.modalIf = true
        if(!this.encryption){
          clipboard.writeText(this.phone.row.kzphone)
        }
      },
      changePhoneState(status){
        this.$http.get('status/edit_kzphone_flag', {
          params: {
            kzId: this.kzId,
            kzphoneFlag: status,
          }
        }).then(data => {
          if (data.code === 100000) {
            this.$Message.success(data.msg)
            this.newPhoneStatus = status
            this.closeModal = '关闭'
          } else {
            this.$Message.error(data.msg)
          }
        })
      },
      // 拨打电话
      OutboundPhone() {
        if(this.callCustomerPO){
          this.$http.get('call/start_back_2_back_call',{
            params:{
              caller:this.userInfo.phone,
              callee:this.phone.row.kzphone,
              kzId:this.phone.row.kzid,
              callId:this.callCustomerPO.callId
            }
          }).then(data=>{
            if(data.code == 100000){
              this.$Message.success('电话已拨通')
            }else{
              this.$Message.error(data.msg)
            }
          })
        }else{
          this.$Message.warning('请联系管理员添加外呼账号')
        }
      },

      //查看通话记录
      seeCallRecord(page) {
        if(this.callCustomerPO){
          this.seeCall.loading = true
          this.Conversation = true
          this.closeModal = '关闭'
          let pageNumber = parseInt(page)?page:1
          this.$http.get('/call/get_recording', {
            params: {
              caller:this.phone.row.kzphone,
              callId:this.callCustomerPO.callId,
              page:pageNumber,
              pageSize:10,
            }
          }).then(data => {
            if (data.code == 100000 ) {
              let callResult = {
                'Success':'正常',
                'NoAnswer':'应答',
                'Rejected':'拒绝',
                'Busy':'忙',
                'AbandonedInContactFlow':'IVR呼损',
                'AbandonedInQueue':'队列呼损',
                'AbandonedRing':'久振不接',
                'QueueOverflow':'等待超时被挂断',
              }
              let callRecord = []
              let backData = data.data.CallDetailRecords.List.CallDetailRecord
              if(backData.length){
                backData.map(item => {
                  let fileName = ''
                  if(item.Recordings.Recording.length && item.Recordings.Recording[0].FileName){
                    fileName = item.Recordings.Recording[0].FileName
                  }
                  callRecord.push( {
                    startTime:timeUtil.getDate(timeUtil.getTimeStamp(item.StartTime)),
                    totalDuration:`${item.Duration}秒`,
                    status:callResult[item.ContactDisposition],
                    customerNumber:item.CallingNumber,
                    clientNumber:item.CalledNumber,
                    fileName,
                  })
                })
              }
              this.seeCall.data = callRecord
              this.seeCall.totalCount = parseInt(data.data.CallDetailRecords.TotalCount)
            } else {
              this.$Message.error('查询失败')
              this.Conversation = false
            }
            this.seeCall.loading = false
          })
        }else{
          this.$Message.warning('请联系管理员添加外呼账号')
        }

      },

      //关闭通话记录
      closeCall(){
        this.Conversation = false
        this.seeCall.data = []
        this.map_url = ''
      },

      //
      changePageCall(value){
        if(value){
          this.seeCallRecord(value)
        }
      }
    },
  }
</script>

<style scoped>
.phone-icon{
  font-size: 18px;
  margin-right: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/render-components/render-phone.vue